import { PlusOutlined } from '@ant-design/icons';
import { Grid } from 'antd';
import { Button, ContentFilters, ContentTopBar } from 'components';
import {
    MainFilters,
    MainFiltersParams,
} from 'components/main-filters/main-filters';
import { CurrencyTabel } from 'features/cms/components/currency';
import { AddCurrencyModal } from 'features/cms/components/currency/Add-currency-madal/add-coupon-modal';
import { CurrencyFilterForm, CurrencyFilterFormPaginated, CurrencyFilterFormValues } from 'features/cms/components/currency-filter-form';
import { useGetCurrency } from 'features/cms/use-cases/get-currency';
import { usePermissions } from 'features/users';
import { usePaginationParams } from 'hooks';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

const { useBreakpoint } = Grid;

const initialFilterValues: CurrencyFilterFormValues = {
    name: undefined,
};

export const CurrencyView = () => {
    const screens = useBreakpoint();
    const permissions = usePermissions();
    const { params, updateParams, resetPage } =
        usePaginationParams<CurrencyFilterFormPaginated>({
            page: 1,
            size: 10,
            order_by: '-rank',
            ...initialFilterValues,
        });

    const { data, isFetching, refetch } = useGetCurrency(params, { retry: false });
    const [currencyEditData, setCurrencyEditData] = useState<any>(undefined);

    const shouldHandleFieldCreation = permissions?.fields.add;

    const handleFiltersChange = (values: CurrencyFilterFormValues) => {
        updateParams(values);
        resetPage();
        refetch();
    };

    const handleMainFiltersChange = (mainParams: MainFiltersParams) => {
        updateParams(mainParams);
        resetPage();
    };
    const [showCurrencyModal, setShowCurrencyModal] = useState(false);
    const formId = 'events-filters-form';

    const handleCloseModal = () => {
        setShowCurrencyModal(false);
        document.body.style.overflow = 'visible';
    }

    const handleOpenModal = () => {
        setShowCurrencyModal(true);
        document.body.style.overflow = 'hidden';
    }

    return (
        <>
            <ContentTopBar
                title={"Currency"}
                renderHeadingContent={
                    <MainFilters onChange={handleMainFiltersChange} />
                }
                renderButtons={
                    <>
                        {shouldHandleFieldCreation ? (
                            <>
                                <Button
                                    icon={!screens.xs ? <PlusOutlined /> : undefined}
                                    onClick={handleOpenModal}
                                    type='primary'
                                >
                                    {"Add Currency"}
                                </Button>
                                <div className={`cstmrightmdl ${showCurrencyModal && "show"}`}>
                                    <AddCurrencyModal showCurrencyModal={showCurrencyModal} refetch={refetch} onClose={handleCloseModal} currencyEditData={currencyEditData} />

                                </div>

                            </>
                        ) : null}
                    </>
                }
            />

            <ContentFilters formId={formId}>
                <CurrencyFilterForm
                    formId={formId}
                    handleFilter={handleFiltersChange}
                    initialValues={initialFilterValues}
                />
            </ContentFilters>

            <CurrencyTabel
                data={data}
                isLoading={isFetching}
                tableParams={params}
                updateParams={updateParams}
                refetch={refetch}
                currencyEditData={currencyEditData}
                setCurrencyEditData={setCurrencyEditData}
            />
            <Outlet />
        </>
    );
};


